export default __webpack_public_path__ + "static/media/drupal.8e0a8e20.svg";